import {useEffect} from 'react';

import {getConnectionSuggestion, getIsLoadingConnectionSuggestionsList, loadConnectionSuggestions} from '@lib/store';

import {useAppDispatch, useAppSelector} from '@hooks';
import {useTranslation} from 'react-i18next';
import {Div, FlexCol, H2, P} from '@quarks';
import {ConnectionSuggestionCard} from '../ConnectionSuggestionCard';
import {StyledSwiperHorizontal} from './styles';
import {Skeleton} from '@molecules';

let didMount = false;

export const ConnectionsSuggestionsList = () => {
  const {t} = useTranslation();
  const {suggestions: connectionSuggestions, ...feedbackData} = useAppSelector(getConnectionSuggestion);
  const dispatch = useAppDispatch();
  const isLoadingConnectionsSuggestions = useAppSelector(getIsLoadingConnectionSuggestionsList);

  useEffect(() => {
    if (!didMount) {
      dispatch(loadConnectionSuggestions());
      didMount = true;
    }
  }, [dispatch]);

  return (
    <Div sm={{padding: '0 16px'}}>
      {isLoadingConnectionsSuggestions ? (
        <>
          <H2>{t('connection:PeopleYouMayKnow')}</H2>
          <StyledSwiperHorizontal className="w-full">
            {Array.from({length: 4}).map((_, index) => (
              <Skeleton
                key={index}
                className="aspect-[270/139] w-[270px] bg-beige-500* rounded-xl"
              />
            ))}
          </StyledSwiperHorizontal>
        </>
      ) : connectionSuggestions && connectionSuggestions.length > 0 ? (
        <>
          <H2>{t('connection:PeopleYouMayKnow')}</H2>
          <StyledSwiperHorizontal>
            {connectionSuggestions.map((connectionSuggestion) => (
              <ConnectionSuggestionCard
                key={connectionSuggestion.connectedUser.id}
                connectionSuggestion={connectionSuggestion}
                feedbackData={{...feedbackData, suggestionId: feedbackData.id}}
              />
            ))}
          </StyledSwiperHorizontal>
        </>
      ) : (
        <FlexCol gap={8}>
          <H2>{t('connection:PeopleYouMayKnow')}</H2>
          <P>{t('connection:EmptySuggestions')}</P>
        </FlexCol>
      )}
    </Div>
  );
};
